import { render, staticRenderFns } from "./fi_update_nudge.vue?vue&type=template&id=c418028a&scoped=true&"
import script from "./fi_update_nudge.vue?vue&type=script&lang=js&"
export * from "./fi_update_nudge.vue?vue&type=script&lang=js&"
import style0 from "./fi_update_nudge.vue?vue&type=style&index=0&id=c418028a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c418028a",
  null
  
)

export default component.exports